export default __webpack_public_path__ + "static/facebookPreview-48604f85e671d8180fa46b14b21df02a.png";